import { render, staticRenderFns } from "./flowadd.vue?vue&type=template&id=8c7ae49a&scoped=true"
import script from "./flowadd.vue?vue&type=script&lang=js"
export * from "./flowadd.vue?vue&type=script&lang=js"
import style0 from "./flowadd.vue?vue&type=style&index=0&id=8c7ae49a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7ae49a",
  null
  
)

export default component.exports